import { Routes } from '@angular/router';
import { authGuard } from '../../../../src/app/auth.guard';
import { CourseViewComponent } from './Pages/course-view/course-view.component';
import { UserViewComponent } from './Pages/user-view/user-view.component';
import { CourseCategoryViewComponent } from './Pages/course-category-view/course-category-view.component';
import { CourseParticipantsViewComponent } from './Pages/course-participants-view/course-participants-view.component';
import { DepartmensViewComponent } from './Pages/departmens-view/departmens-view.component';
import { UnauthorizedComponent } from './Pages/unauthorized/unauthorized.component';
import { InfoFrontpageComponent } from './Pages/Info-frontpage/Info-frontpage.component';
import { UserRoleType } from 'BaseDataTypes';

const trainingtrackingRouteConfig: Routes = [
  { path: '', redirectTo: 'info', pathMatch: 'full', title: '' },
  {
    path: 'info',
    title: 'Info',
    component: InfoFrontpageComponent,
    canActivate: [authGuard],
    data: {
      allowedUserRoleType: [
        UserRoleType.Admin,
        UserRoleType.User,
        UserRoleType.Manager,
      ],
    },
  },
  {
    path: 'kurser',
    title: 'Kurser',
    component: CourseParticipantsViewComponent,
    canActivate: [authGuard],
    data: {
      allowedUserRoleType: [
        UserRoleType.Admin,
        UserRoleType.Manager,
        UserRoleType.User,
      ],
    },
  },
  {
    path: 'kursusoversigt',
    title: 'Kursusoversigt',
    component: CourseViewComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin] },
  },
  {
    path: 'kursuskategorier',
    title: 'Kursuskategorier',
    component: CourseCategoryViewComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin] },
  },
  {
    path: 'brugere',
    title: 'Brugere',
    component: UserViewComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin] },
  },
  {
    path: 'afdelinger',
    title: 'Afdelinger',
    component: DepartmensViewComponent,
    canActivate: [authGuard],
    data: { allowedUserRoleType: [UserRoleType.Admin] },
  },
  // {
  //   path: 'internaltitles',
  //   title: 'internaltitles',
  //   component: InternalTitlesViewComponent,
  //   canActivate: [authGuard],
  //   data: { allowedUserRoleType: [UserRoleType.Admin], siteCheck: 'roleId' },
  // },
  // {
  //   path: 'kursusroller',
  //   title: 'kursusroller',
  //   component: CourseRoleViewComponent,
  //   canActivate: [authGuard],
  //   data: { allowedUserRoleType: [UserRoleType.Admin], siteCheck: 'courseRoleId' },
  // },
  { path: 'unauthorized', component: UnauthorizedComponent },
];

export default trainingtrackingRouteConfig;
